import React from "react";
import { useQuery } from "@tanstack/react-query";
import { Clock, MessageSquareText, Package, Star } from "lucide-react";
import { SEO } from "@/components/common/SEO";
import { api } from "@/lib/api";
import { ShopifyConnectionCard } from "@/components/account/ShopifyConnectionCard";
import { ReviewModerationPanel } from "@/components/account/ReviewModerationPanel";

function StatCard({ icon: Icon, label, value, hint, testId }) {
  return (
    <div className="border border-border bg-white/60 p-5" data-testid={testId}>
      <div className="flex items-center justify-between">
        <p className="text-luxe text-[10px] text-muted-foreground">{label}</p>
        <Icon size={16} className="text-gold" />
      </div>
      <p className="mt-3 font-serif text-4xl font-light text-ink" data-testid={`${testId}-value`}>{value}</p>
      {hint && <p className="mt-1 text-xs text-muted-foreground">{hint}</p>}
    </div>
  );
}

function StatsRow() {
  const { data, isLoading } = useQuery({ queryKey: ["admin-stats"], queryFn: async () => (await api.get("/admin/stats")).data });
  const r = data?.reviews || {};
  const v = (x) => (isLoading ? "…" : x ?? "–");
  return (
    <section className="grid grid-cols-2 gap-4 lg:grid-cols-4" data-testid="admin-stats">
      <StatCard icon={MessageSquareText} label="Total reviews" value={v(r.total)} hint={`${r.published ?? 0} live · ${r.hidden ?? 0} hidden`} testId="admin-stat-reviews" />
      <StatCard icon={Clock} label="Pending approval" value={v(r.pending)} hint="Awaiting your decision" testId="admin-stat-pending" />
      <StatCard icon={Star} label="Average rating" value={v(data?.average_rating != null ? data.average_rating.toFixed(1) : "–")} hint={`${data?.replied ?? 0} replied by ÉLORA`} testId="admin-stat-rating" />
      <StatCard icon={Package} label="Products live" value={v(data?.products)} hint={data?.catalogue_source === "shopify" ? "From Shopify" : "Sample catalogue"} testId="admin-stat-products" />
    </section>
  );
}

export default function AdminDashboardPage() {
  return (
    <div className="space-y-12" data-testid="admin-dashboard">
      <SEO title="Admin Dashboard" />
      <div>
        <p className="text-luxe text-[10px] text-gold">Overview</p>
        <h1 className="mt-2 font-serif text-3xl font-light text-ink sm:text-4xl">Dashboard</h1>
      </div>

      <StatsRow />

      <section className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        <ShopifyConnectionCard />
      </section>

      <ReviewModerationPanel defaultStatus="all" />
    </div>
  );
}
